module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-22.dd8b7eb9.png";